import type { EventCatalogEntry } from "@repo/vihangam-yog-shared";

/**
 * Where an event is held, with a Map link when the catalog has one. The
 * arrive-by time sits in a Callout at each call site, so it reads as the
 * highlighted line the organisers asked for. Renders nothing for a day
 * with no venue yet.
 */
export function EventWhere({
  event,
  className = "",
}: {
  event: EventCatalogEntry;
  className?: string;
}) {
  const { venue } = event;
  if (!venue) {
    return null;
  }
  const place = [venue.name, venue.hall, venue.suburb]
    .filter(Boolean)
    .join(", ");
  return (
    <span className={`block text-sm text-ink-soft ${className}`}>
      {place}
      {venue.mapUrl ? (
        <>
          {" "}
          <a
            href={venue.mapUrl}
            target="_blank"
            rel="noreferrer"
            className="font-medium text-teal-deep underline underline-offset-4"
          >
            Map
          </a>
        </>
      ) : null}
    </span>
  );
}
